<template>
    <b-button
        @click="() => { modalState = true }"
        size="sm"
        :disabled="disabled"
        :variant="(httpRequestInProgress) ? 'success': 'primary'"
        block
    ><!-- button -->
        <span v-if="httpRequestInProgress">
            <b-spinner
                type="grow"
                label="Loading..."
                small
            />
            </span>
        <span v-else>Freigeben</span>
        <b-modal
            v-model="modalState"
            id="modal-unfreeze-order"
            title="Bestellung Freigeben"
            @ok="submit()"
            cancel-title="abbrechen"
            size="md"
        ><!-- modal -->
            Diese Bestellung wirklich freigeben?
        </b-modal>
    </b-button>  
</template>
<script>
    export default {
        props: ['customerOrder', 'orderStates']
        , data() {
            return {
                modalState: false,
                httpRequestInProgress: false
            }
        }
        , computed: {
           disabled: function() {
                return this.httpRequestInProgress
                 || [ this.orderStates.codes.DONE
                  , this.orderStates.codes.REFUND
                  , this.orderStates.codes.REFUND_OK
                  , this.orderStates.codes.WAIT
                  , this.orderStates.codes.OPEN
                ].includes(this.customerOrder.orderState);
            }
        }
        , methods: {
            submit() {

                let payload = {
                    customerOrderId: this.customerOrder.id
                }
                this.httpRequestInProgress = true;
                // guarantees a minium delay of 500ms or longer, if request takes longer. The animation looks very consistent thereby.
                //NICE very cool trick, gotta remember this one
                Promise.all([
                    axios.post('/customerorder/action/unfreezeorder', payload),
                    new Promise(r => setTimeout(r, 500))
                ]).then( () => {
                    this.customerOrder.orderState = this.orderStates.codes.WAIT;
                    this.httpRequestInProgress = false;
                }).catch( error => {
                    alert("konnte Status nicht ändern");
                    console.error(error);
                });
            }
        }
    }
</script>
